/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import type { BibleBook, BibleBookId } from "@packages/sdk";
import type { ThemeType } from "@packages/ui";
import { useScrollToOnLoad } from "@packages/ui";

import type { BibleNavBookItemProps } from "./BibleNavBookItem";
import { BibleNavBookItem } from "./BibleNavBookItem";
import { BibleNavSectionHeader } from "./BibleNavSectionHeader";

type BibleNavBookSectionProps = {
  headerCSS: Interpolation<ThemeType>;
  books: BibleBook[];
  itemCSS: Interpolation<ThemeType>;
  itemStyle: BibleNavBookItemProps["itemStyle"];
  title: string;
  titlePosition?: number;
  navBook: BibleBookId;
  onItemClick: (id: BibleBookId, e: Event | MouseEvent) => void;
};

export const BibleNavBookSection = ({
  headerCSS,
  title,
  titlePosition,
  books,
  itemCSS,
  itemStyle,
  navBook,
  onItemClick,
}: BibleNavBookSectionProps) => {
  const selectedBookRef = useScrollToOnLoad<HTMLDivElement>({
    block: "center",
  });

  return books?.length ? (
    <>
      <BibleNavSectionHeader css={headerCSS} position={titlePosition}>
        {title}
      </BibleNavSectionHeader>
      {books.map((b, idx) => (
        <BibleNavBookItem
          key={`${b.id}_item`}
          b={b}
          idx={idx}
          onItemClick={onItemClick.bind(null, b.id)}
          itemStyle={itemStyle}
          selected={b.id === navBook}
          css={itemCSS}
          ref={b.id === navBook ? selectedBookRef : null}
        />
      ))}
    </>
  ) : null;
};
